function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 85.337h512v113.775H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 312.888h512v113.775H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M256 218.899l9.208 28.341h29.803L270.9 264.759l9.211 28.342L256 275.585l-24.111 17.516 9.211-28.342-24.111-17.519h29.803z"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M306.706 118.725v34.628c0 5.456-4.439 9.894-9.894 9.894v14.84c13.639 0 24.734-11.096 24.734-24.735v-34.628h-14.84v.001zm-106.358 34.627c0 5.456-4.439 9.894-9.894 9.894v14.841c13.639 0 24.734-11.096 24.734-24.735v-34.628h-14.84v34.628z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.449 118.728h14.84v34.627h-14.84zm-22.265 19.784c0 1.363-1.11 2.474-2.473 2.474s-2.473-1.11-2.473-2.474v-19.787h-14.84v19.787a2.477 2.477 0 01-2.473 2.474 2.477 2.477 0 01-2.473-2.474v-19.787H222.61v19.787c0 9.548 7.767 17.314 17.314 17.314a17.21 17.21 0 009.894-3.118 17.214 17.214 0 009.894 3.118c.74 0 1.468-.052 2.185-.144-1.052 4.333-4.953 7.564-9.604 7.564v14.84c13.639 0 24.734-11.096 24.734-24.735v-34.627h-14.84v19.787h-.003z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.609 163.25h22.261v14.84h-22.261z"
}));

const SvgSomaliland = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSomaliland, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/somaliland.0c0afa41.svg";
export { ForwardRef as ReactComponent };